<template>
    <div style="display: flex; align-items: center;">
        <el-upload class="avatar-uploader" :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest">
            <img v-if="formValue" :src="formValue" class="avatar" :preview-src-list="[formValue]">

            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div v-if="tip" slot="tip" class="el-upload__tip" style="width: auto;">
                {{ tip }}
            </div>
        </el-upload>
        <div class="aaaa">
            <el-button @click="deleteUrl" type="danger" icon="el-icon-delete" size="mini"></el-button>

        </div>
        <div class="yulan" v-if="formValue">
            <el-button @click="handlePictureCardPreview" type="danger" size="mini">预览</el-button>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
import { uploadOSSRequest, getAliyunOssToken } from "@/api/common";

export default {
    name: "activityCustomUpload",
    props: {
        formName: {
            type: String,
            default: "",
        },
        formValue: {
            type: String,
            default: "",
        },
        tip: {
            type: String,
            default: "",
        },
        num: {
            type: Number,
            default: "",
        },
        id: {
            type: Number,
            default: "",
        },
        source: {
            type: String,
            default: "",
        },
    },
    data: function () {
        return {
            ossAction: "",
            formLoading: false,
            dialogVisible: false,
            onSubmitLoading: false,
            dialogImageUrl: "",
        };
    },
    mounted() {},
    methods: {
        uploadOSSRequest(file) {
            let that = this;
            this.updateLoading = true;
            console.log(file);
            getAliyunOssToken().then((res) => {
                uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                    this.$emit("uploadSuccess", {
                        formName: that.formName,
                        fileUrl,
                        id: that.id,
                    });
                });
            });
        },
        deleteUrl() {
            console.log(this.formName);
            if (this.source != "meetvideo") {
                this.$emit("uploadSuccess", {
                    formName: this.formName,
                    fileUrl: "",
                    id: this.id,
                }),
                    this.$emit("deleteList", {
                        title: this.formName,
                        id: this.id,
                    });
            } else {
                this.$confirm("确认要删除该视频吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.$emit("uploadSuccess", {
                            formName: this.formName,
                            fileUrl: "",
                            id: this.id,
                        }),
                            this.$emit("deleteList", {
                                title: this.formName,
                                id: this.id,
                            });
                    })
                    .catch(() => {});
            }
        },
        handlePictureCardPreview() {
            this.dialogImageUrl = this.formValue;
            this.dialogVisible = true;
        },
    },
};
</script>
<style scoped>
.avatar-uploader {
    display: inline-block;
}
.aaaa {
    width: 50px;
    height: 50px;
    position: relative;
}
.yulan {
    position: relative;
    width: 50px;
    height: 50px;
    bottom: -15px;
}
.yulan .el-button {
}
.aaaa .el-button {
    left: 0;
    bottom: 0px;
}
.el-button {
    position: absolute;
    bottom: 15px;
    margin-left: 10px;
}
</style>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    min-height: 70px;
    line-height: 70px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    object-fit: cover;
    display: block;
}

h1 {
    margin-bottom: 15px;
}
.el-upload-list__item-actions {
    position: absolute;
    top: 30%;
    right: 40%;
}
</style>